var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "air-approve-settings" }, [
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: { no: "onSave", type: "primary" },
                on: { click: _vm.onSave }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
            ),
            _c(
              "el-button",
              {
                attrs: { no: "onRefresh", type: "primary" },
                on: { click: _vm.onRefresh }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.Refresh")))]
            ),
            _c(
              "el-button",
              { attrs: { no: "onCancel" }, on: { click: _vm.onCancel } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
            )
          ],
          1
        )
      ]),
      _c("air-markup", { ref: "airMarkUp" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }